import {
	EPIC_LINK_FIELD,
	RICH_TEXT_FIELD,
	COMPONENTS_FIELD,
	ISSUE_RESTRICTION_FIELD,
	LABEL_FIELD,
	MULTI_VERSION_FIELD,
	CHECKBOX_FIELD,
	MULTI_SELECT_FIELD,
	ATTACHMENTS_FIELD,
	MUTLI_GROUP_PICKER_FIELD,
	MULTI_USER_PICKER_FIELD,
	CMDB_FIELD,
	ASSET_FIELD,
	PARENT_LINK_FIELD,
	REPORTER_FIELD,
	SPRINT_FIELD,
	ISSUE_LINK_FIELD,
	TEXT_FIELD,
	CONNECT_TEXT_FIELD,
	FORGE_STRING_FIELD,
	NUMBER_FIELD,
	CONNECT_NUMBER_FIELD,
	FORGE_NUMBER_FIELD,
	TEXT_AREA_FIELD,
	MESSAGE_EDIT_FIELD,
	TIME_TRACKING_FIELD,
	PARENT_FIELD,
	USER_PICKER_FIELD,
	PEOPLE_FIELD,
	ENTITLEMENT_FIELD,
} from '../../../../../common/constants/graphql-field-types.tsx';

export const FIELDS_WITH_SELECTED_PROJECT = [
	EPIC_LINK_FIELD,
	RICH_TEXT_FIELD,
	COMPONENTS_FIELD,
	ISSUE_RESTRICTION_FIELD,
	ATTACHMENTS_FIELD,
	CMDB_FIELD,
	ASSET_FIELD,
	PARENT_LINK_FIELD,
	PARENT_FIELD,
	REPORTER_FIELD,
	SPRINT_FIELD,
	MULTI_USER_PICKER_FIELD,
	USER_PICKER_FIELD,
	PEOPLE_FIELD,
] as const;

export const FIELDS_WITH_SELECTED_ISSUE_TYPE = [
	ASSET_FIELD,
	PARENT_FIELD,
	RICH_TEXT_FIELD,
] as const;

export const FIELDS_NEEDING_FORM_CONTEXT = [PARENT_LINK_FIELD, EPIC_LINK_FIELD] as const;

export const FIELDS_WITH_ON_INPROGRESS_CHANGE = [ATTACHMENTS_FIELD] as const;

/* temporary fix for multiSelect fields -> https://atlassian.slack.com/archives/CVBKMNUKF/p1613368505043500 */
export const FORCE_RENDER_ON_TAB_CHANGE = [
	LABEL_FIELD,
	MULTI_VERSION_FIELD,
	CHECKBOX_FIELD,
	MULTI_SELECT_FIELD,
	MUTLI_GROUP_PICKER_FIELD,
	MULTI_USER_PICKER_FIELD,
	COMPONENTS_FIELD,
	ISSUE_RESTRICTION_FIELD,
] as const;

export const FIELDS_NEEDING_COMPLETE_FORM_STATE = [CMDB_FIELD, ENTITLEMENT_FIELD] as const;

export const FIELDS_NEEDING_GET_FORM_STATE = [RICH_TEXT_FIELD] as const;

export const RENDER_BATCH_SIZE_DENOMINATOR = 10;

export const FIELDS_WITH_EXTENSION_PROPS = [RICH_TEXT_FIELD] as const;

export const FIELDS_NEEDING_CREATE_LINKED_ISSUE_INFO = [ISSUE_LINK_FIELD] as const;

export const FIELDS_WITHOUT_DROPDOWN_MENU = [
	TEXT_FIELD,
	CONNECT_TEXT_FIELD,
	FORGE_STRING_FIELD,
	RICH_TEXT_FIELD,
	NUMBER_FIELD,
	CONNECT_NUMBER_FIELD,
	FORGE_NUMBER_FIELD,
	TEXT_AREA_FIELD,
	MESSAGE_EDIT_FIELD,
	TIME_TRACKING_FIELD,
] as const;
